import "whatwg-fetch";
import CONFIG from "./config";
import i18next from "i18next";
import { Browser } from "core/utils";
import { STORAGE_KEYS } from "core/utils/constants";
const methods = ["get", "post", "put", "delete", "patch", "upload"];
class ApiService {
    constructor(url = null, headers = null) {
        this.headers = headers;
        const http = CONFIG.ssl ? "https" : "http";
        if (url) {
            this.url = `${http}://${CONFIG.domain}/${url}`;
        }
        else {
            this.url = `${http}://${CONFIG.domain}`;
        }
        methods.forEach(method => {
            this[method] = (url, body, headers = null, isOtp = false, setCookie = false) => {
                return this.callApi(method, url, body, headers, isOtp, setCookie);
            };
        });
    }

    callApi = (METHOD, url = "", body, headers = null, isOtp = false, setCookie = false) => {
        let sessionId = Browser.getSavedInfo(STORAGE_KEYS.SESSION_ID);
        if (isOtp) {
            sessionId = Browser.getSavedInfo(STORAGE_KEYS.PRESESSION_ID);
        }
        let _headers = Object.assign(
            {
                "Content-Type": "application/json",
                'Accept': 'application/json',
                sessionId,
                "Accept-Language": i18next.language ? i18next.language : "jp",
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Expose-Headers": "Content-Disposition",
                "Pragma": "no-cache",
                "X-Client-Type": "web"
            },
            this.headers,
            headers
        );
        if (METHOD === "upload") {
            METHOD = 'post';
            _headers = {
                sessionId,
                'Accept': 'application/json',
                "Accept-Language": i18next.language ? i18next.language : "jp",
            }
        }

        const options = {
            method: METHOD,
            headers: _headers,
            mode: "cors",
        };
        if (setCookie) {
            options.credentials = 'include';
        }
        let queryString = "";
        if (METHOD.toUpperCase() === "GET") {
            queryString = this.buildQueryString(body);
        } else {
            if (body) {
                if (!_headers["Content-Type"]) {
                    options.body = body;
                } else {
                    options.body = JSON.stringify(body);
                }
            }
        }

        if (url) {
            url = "/" + url;
        }
        let _url = this.url + url
        if (queryString !== "") {
            _url = _url + "?" + queryString;
        }

        return fetch(_url, options)


    };

    buildQueryString = body => {
        if (body) {
            let searchParams = new URLSearchParams();
            Object.keys(body).forEach((key) => {
                if (body[key] && body[key] !== "null") {
                    searchParams.append(key, body[key]);
                }
            });
            return searchParams.toString();
        }

        return "";
    };
}

export default ApiService;
